"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delScoreGoods = delScoreGoods;
exports.delScoreLevel = delScoreLevel;
exports.editScoreGoods = editScoreGoods;
exports.editScoreLevel = editScoreLevel;
exports.getLogTypeList = getLogTypeList;
exports.getOrderStatusList = getOrderStatusList;
exports.getScoreGoodsList = getScoreGoodsList;
exports.getScoreLevelList = getScoreLevelList;
exports.getScoreLogList = getScoreLogList;
exports.getScoreMemberList = getScoreMemberList;
exports.getScoreOrderList = getScoreOrderList;
exports.returnOrder = returnOrder;
exports.successOrder = successOrder;
var _fetch = _interopRequireDefault(require("@/utils/fetch"));
/**
 * 积分管理
 */

// 等级列表
function getScoreLevelList(params) {
  return _fetch.default.get('/Supplier/score/getLevelList', params);
}

// 等级修改或添加
function editScoreLevel(params) {
  return _fetch.default.post('/Supplier/score/editLevel', params, true);
}

// 删除等级
function delScoreLevel(params) {
  return _fetch.default.post('/Supplier/score/delLevel', params, true);
}

// 积分列表
function getScoreMemberList(params) {
  return _fetch.default.get('/Supplier/score/getMemberList', params);
}

// 积分日志类型列表
function getLogTypeList(params) {
  return _fetch.default.get("/Supplier/score/getLogTypeList", params);
}

// 积分日志
function getScoreLogList(params) {
  return _fetch.default.get('/Supplier/score/getLogList', params);
}

// 商品管理
function getScoreGoodsList(params) {
  return _fetch.default.get('/Supplier/score/getGoodsList', params);
}

// 商品修改或添加
function editScoreGoods(params) {
  return _fetch.default.post('/Supplier/score/editGoods', params, true);
}

// 删除商品
function delScoreGoods(params) {
  return _fetch.default.post('/Supplier/score/delGoods', params, true);
}

// 获取订单状态列表
function getOrderStatusList(params) {
  return _fetch.default.get("/Supplier/score/getOrderStatusList", params);
}

// 订单列表
function getScoreOrderList(params) {
  return _fetch.default.get('/Supplier/score/getOrderList', params);
}

// 处理订单
function successOrder(params) {
  return _fetch.default.post('/Supplier/score/successOrder', params, true);
}

// 退回订单
function returnOrder(params) {
  return _fetch.default.post('/Supplier/score/returnOrder', params, true);
}